import ExportAPI from '@/apis/business/common/export-api.js'
import { HttpStatusCode } from '@/common/constant'
import CommonFn from '@/common/common-fn.ts'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    /**
     * Xuất khẩu dữ liệu
     * @param {*} context
     * @param {*} param
     * @returns
     * @author BNDung
     */
    exportData (context, param) {
      return new Promise((resolve, reject) => {
        // const paramCustom = []
        // for (var i = 0; i < Object.keys(param).length; i++) {
        //   paramCustom.set(Object.keys(param)[i], Object.values(param)[i])
        // }
        ExportAPI.postAsync('param/', {
          ReportID: param.ReportID,
          ModuleType: param.ModuleType,
          ControllerName: param.ControllerName,
          Token: param.Token,
          FunctionName: param.FunctionName,
          GetDataParam: param.GetDataParam
        })
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              CommonFn.downloadFileExcel(res.Data, false) // false = in ra nhiều sheet
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
